<template>
	<div id="prazo-geral" class="prazo-geral relative">
		<section class="flex flex-col w-full">
			<h4 class="subtitle mt-10 mb-4 font-bold">Dados gerais</h4>

			<ld-tooltip parent="#prazo-geral #titulo-prazo input" v-if="disabled || prazoDesativado || prazoFinalizado || prazoPerdido">
				<template v-slot:target>
					<div id="titulo-prazo" class="relative">
						<vs-input

							:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
							name="titulo"
							class="w-full mb-4"
							label="Título do prazo"
							v-model="tituloObj"
						></vs-input>
					</div>
				</template>

				<template v-slot:content>
					{{tituloObj}}
				</template>
			</ld-tooltip>

			<vs-input
				v-else
				:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
				name="titulo"
				class="w-full mb-4"
				label="Título do prazo"
				v-model="tituloObj"
			></vs-input>



			<div v-if="responsaveis" class="w-full mb-4">
				<ld-select
					:disabled="!(responsaveis && responsaveis.length) || disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
					:parent="`${parent} #prazo-geral`"
					name="responsavel"
					label="Responsável do prazo (Opcional)"
					:model.sync="responsavelObj"
					:list.sync="responsaveis"
					:search="searchResponsaveis"
					:moreData="moreResponsaveis"
					:changed="setCiencia"
				/>
			</div>

			<vs-input
				v-else
				name="responsavel"
				class="w-full mb-4"
				label="Responsável do prazo (Opcional)"
				:disabled="true"
			></vs-input>

			<div v-if="supervisores" class="w-full mb-4">
				<ld-select
					:disabled="!(supervisores && supervisores.length) || disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
					:parent="`${parent} #prazo-geral`"
					name="supervisor"
					label="Supervisor do Prazo"
					:model.sync="supervisorObj"
					:list.sync="supervisores"
					:search="searchSupervisores"
					:moreData="moreSupervisores"
				/>
			</div>

			<vs-input
				v-else
				name="supervisor"
				class="w-full mb-4"
				label="Supervisor do Prazo"
				:disabled="true"
			></vs-input>

			<vs-input
				name="acao"
				class="w-full mb-4"
				label="Ação"
				v-model="acaoObj"
				:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
			></vs-input>

			<div class="flex mb-4">
				<div class="mr-12">
					<label class="vs-input--label">Tem prioridade?</label>
					<div class="btn-group">
						<vs-button
							:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
							size="small"
							type="border"
							color="white"
							class="button-prioridade"
							:class="{
								active: prioridadeObj == true
							}"
							@click="prioridadeObj = true"
							>Sim</vs-button
						>
						<vs-button
							:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
							size="small"
							type="border"
							color="white"
							class="button-prioridade"
							:class="{
								active: prioridadeObj == false
							}"
							@click="prioridadeObj = false"
							>Não</vs-button
						>
					</div>
					<input type="hidden" name="prioridade" v-model="prioridadeObj">
				</div>

				<div v-if="!edicao">
					<label class="vs-input--label">Com ciência?</label>
					<div class="btn-group">
						<vs-button
							:disabled="colaborador && colaborador.pk == responsavelObj || disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
							size="small"
							type="border"
							color="white"
							class="button-ciencia"
							:class="{
								active: cienciaObj == true
							}"
							@click="cienciaObj = true"
							>Sim</vs-button
						>
						<vs-button
							:disabled="colaborador && colaborador.pk == responsavelObj || disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
							size="small"
							type="border"
							color="white"
							class="button-ciencia"
							:class="{
								active: cienciaObj == false
							}"
							@click="cienciaObj = false"
							>Não</vs-button
						>
					</div>
					<input type="hidden" name="ciente" v-model="cienciaObj">
				</div>
			</div>

			<div class="container-descricao w-full">
				<label class="vs-input--label">Descrição do prazo</label>
				<vs-textarea
					:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
					name="descricao"
					class="descricao-prazo mb-4"
					v-model="descricaoObj"
				/>
			</div>
		</section>
	</div>
</template>

<script>

import Usuario from "../../../../../../models/Usuario";
import Colaborador from '../../../../../../models/Colaborador';

export default {
	data() {
		return {
			responsaveis: null,
			supervisores: null
		};
	},
	props: {
		titulo: {
			required: true
		},
		responsavel: {
			required: true
		},
		supervisor: {
			required: false
		},
		acao: {
			required: true
		},
		prioridade: {
			required: true
		},
		ciencia: {
			required: true
		},
		descricao: {
			required: true
		},
		parent: {
			type: String,
			required: true
		},
		edicao: {
			default: false,
			type: Boolean
		},
		prazoDesativado: {
			required: true
		},
		prazoFinalizado: {
			required: true
		},
		prazoPerdido: {
			required: true
		},
	},
	computed: {
		disabled() {
			return ((!this.$permissions.can('prazomodificar') && this.edicao) || (!this.$permissions.can('prazoadicionar') && !this.edicao)) && !this.$permissions.can('autenticadosuperuser');
		},
		colaborador() {
			return Colaborador.getColaborador();
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		tituloObj: {
			set(value) {
				this.$emit("update:titulo", value);
			},
			get() {
				return this.titulo;
			}
		},
		responsavelObj: {
			set(value) {
				this.$emit("update:responsavel", value);
			},
			get() {
				return this.responsavel;
			}
		},
		supervisorObj: {
			set(value) {
				this.$emit("update:supervisor", value);
			},
			get() {
				return this.supervisor;
			}
		},
		acaoObj: {
			set(value) {
				this.$emit("update:acao", value);
			},
			get() {
				return this.acao;
			}
		},
		prioridadeObj: {
			set(value) {
				this.$emit("update:prioridade", value);
			},
			get() {
				return this.prioridade;
			}
		},
		cienciaObj: {
			set(value) {
				this.$emit("update:ciencia", value);
			},
			get() {
				return this.ciencia;
			}
		},
		descricaoObj: {
			set(value) {
				this.$emit("update:descricao", value);
			},
			get() {
				return this.descricao;
			}
		}
	},
	methods: {
		reordenarResponsaveis(responsaveis) {
			if (this.colaborador) {
				const index = responsaveis.findIndex(responsavel => responsavel.pk == this.colaborador.pk);
				if (index >= 0) {
					const responsavelRemovido = responsaveis.splice(index, 1);
					responsavelRemovido[0].nome = responsavelRemovido[0].nome + " [ EU MESMO ]";
					responsaveis.unshift(responsavelRemovido[0]);
				}
			}
		},
		async moreResponsaveis(params) {
			const data = {
				count: 0,
				data: []
			};

			const {
				usuarios,
				totalUsuarios
			} = await Usuario.getUsuariosGerenciados(this.empresaPk, params);

			this.reordenarResponsaveis(usuarios);

			data.count = totalUsuarios;
			data.data = usuarios.map(usuario => {
				return {
					text: usuario.nome,
					value: usuario.pk
				};
			});

			return data;
		},
		async searchResponsaveis(searchValue) {
			const params = {
				limit: 20,
				search: searchValue,
				ordering: "nome"
			};

			const { usuarios } = await Usuario.getUsuariosGerenciados(
				this.empresaPk,
				params
			);

			this.reordenarResponsaveis(usuarios);

			return usuarios.map(usuario => {
				return {
					text: usuario.nome,
					value: usuario.pk
				};
			});
		},
		async getResponsaveis() {
			try {
				const { usuarios } = await Usuario.getUsuariosGerenciados(
					this.empresaPk,
					{
						limit: 20,
						ordering: "nome"
					}
				);

				this.reordenarResponsaveis(usuarios);

				this.responsaveis = usuarios.map(usuario => {
					return {
						text: usuario.nome,
						value: usuario.pk
					};
				});
			} catch (error) {
				console.error(error);
			}
		},
		setCiencia({value}) {
			if (!this.edicao && this.colaborador) {
				this.cienciaObj = this.colaborador.pk == value;
			}
		},
		async moreSupervisores(params) {
			const data = {
				count: 0,
				data: []
			};

			const {
				usuarios,
				totalUsuarios
			} = await Usuario.getUsuariosSupervisores(this.empresaPk, params);

			data.count = totalUsuarios;
			data.data = usuarios.map(usuario => {
				return {
					text: usuario.nome,
					value: usuario.pk
				};
			});

			return data;
		},
		async searchSupervisores(searchValue) {
			const params = {
				limit: 20,
				search: searchValue,
				ordering: "nome"
			};

			const { usuarios } = await Usuario.getUsuariosSupervisores(
				this.empresaPk,
				params
			);

			return usuarios.map(usuario => {
				return {
					text: usuario.nome,
					value: usuario.pk
				};
			});
		},
		async getSupervisores() {
			try {
				const { usuarios } = await Usuario.getUsuariosSupervisores(
					this.empresaPk,
					{
						limit: 20,
						ordering: "nome"
					}
				);

				this.supervisores = usuarios.map(usuario => {
					return {
						text: usuario.nome,
						value: usuario.pk
					};
				});

				// Se usuário atual é supervisor e não há supervisor definido, definir como padrão
				if (!this.edicao && this.colaborador && !this.supervisorObj) {
					const colaboradorAtual = this.colaborador;
					// O endpoint retorna Colaboradores, então comparamos pk do Colaborador
					const colaboradorSupervisor = usuarios.find(u => u.pk === colaboradorAtual.pk);
					if (colaboradorSupervisor) {
						this.supervisorObj = colaboradorAtual.pk;
					}
				}
			} catch (error) {
				console.error(error);
			}
		}
	},
	mounted() {
		this.getResponsaveis();
		this.getSupervisores();
	}
};
</script>

<style lang="scss" src="./geral.scss"></style>
